import { environment } from 'environments/environment';

export const catchAppError = (error: unknown): void => {
	if (!environment.production) {
		console.error('Error occurred:', error);
	}
};
